import {Injectable} from '@angular/core';
import {Event} from '../models/event';
import {DayService} from './day.service';
import {ActivityService} from './activity.service';
import {TopicService} from './topic.service';
import {AngularFireFunctions} from '@angular/fire/compat/functions';
import {lastValueFrom} from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class EventPreviewService {

  public currentEvent: Event;
  public htmlPreview: any;

  constructor (
    private ff: AngularFireFunctions,
    public _dayService: DayService,
    public _activityService: ActivityService,
    public _topicService: TopicService
  ) { }

  async _getFullEvent (id: any) {
    const getFullEvent = this.ff.httpsCallable('getFullEvent');
    return getFullEvent(id)
  }

  getFullEvent (id: any): Promise<any> {
    const callable = this.ff.httpsCallable('getFullEvent');
    return lastValueFrom(callable(id));
  }

  makeHTMLDataForDates (data) {

    let html_1 = "";
    let html_2 = "";

    if (data.days.length != 0) {

      data.days.sort(this.compareDays)

      data.days.forEach((day) => {

        if (this.formatDate(day.date) != '26/05/2023') {
          html_2 = this.makeDay(day)
        } else if (this.formatDate(day.date) != '27/05/2023') {
          html_1 = this.makeDay(day)
        }

      })

    }

    return {'html_1': html_1, 'html_2': html_2};
  }

  makeDay (day: any) {
    let html: string = ''

    /*
    html += "<div style='padding: 10px; color: white; background-color: rgb(7, 77, 138); font-weight: bold; border-radius: 6px;'>"
    html += this.formatDate(day.date)
    html += "</div>"
    */

    if (day.activities.length != 0) {

      day.activities.sort(this.compareActivities)

      day.activities.forEach((activity) => {

        html += "<div style='padding: 5px 10px 5px 10px; margin: 10px 0 10px 0; color: white; background-color: rgb(33,142,241); font-weight: bold; border-radius: 6px;'>"
        html += "<b>" + activity.startTime + "</b>"
        html += " - " + activity.name
        html += "</div>"

        // html += "<div style='padding: 5px 10px 5px 10px; margin: 10px 0 10px 0; color: white; background-color: rgb(33,142,241); font-weight: bold; border-radius: 6px;'>"
        html += "<div style='margin: 5px 0px 5px 20px; color: rgba(216,24,34, .8)'>"
        html += "<b>&#149;" + activity.location + "</b>"
        html += "</div>"

        if (activity.agenda.length != 0) {
          html += "<div style='margin: 5px 0 20px 10px;'>"
          activity.agenda.forEach((item) => {
            html += "<div style='padding:0 0 0 10px; color:rgb(0,66,94);'>"
            html += item.role_name + " - " + item.member_name
            html += "</div>"
          })
          html += "</div>"
        }



        if (activity.topics.length != 0) {

          activity.topics.sort(this.compareTopics)

          html += "<div style='margin: 0 0 20px 20px;'>"
          activity.topics.forEach((topic) => {

            html += "<b style='color:rgb(242,140,146);'>" + topic.startTime + "</b> - " + topic.name + " ( " + topic.duration + " min )"

            if (topic.agenda.length != 0) {

              html += "<div style='padding: 5px 0 20px 0px;'>"
              topic.agenda.forEach((item) => {
                html += "<div>" + item.role_name + " - " + item.member_name + "</div>"
              })
              html += "</div>"

            }

          })
          html += "</div>"
        }


      })

    }

    return html
  }

  makeHTMLDataForLocatios (data) {

    let dayArray: any[] = [];

    let locationArray: any = []

    data.days.sort(this.compareDates)

    data.days.forEach((day) => {

      day.activities.sort(this.compareTime)

      day.activities.forEach((activity) => {

        activity.topics.sort(this.compareTime)

        let location = locationArray.find((e) => {
          return e.location.trim().toUpperCase() == activity.location.trim().toUpperCase()
        })

        if (location) {

          location.activities.push(activity)

        } else if (!location) {

          location = {
            'location': activity.location.trim().toUpperCase(),
            'activities': []
          }

          location.activities.push(activity)

          locationArray.push(location)

        }

      })

    })

    locationArray.sort(this.compareLocation)
    /*

    dayArray = []
    let currentDay: any;

    locationArray.forEach((local) => {
      console.log(JSON.stringify(local.location))

      local.activities.forEach((activity) => {
        let _day: any = new Date(activity.date._seconds * 1000)
        console.log(_day)
        if (currentDay != _day) {
          currentDay = { 'day': _day, 'activities': []}

        }

      })

      console.log("---------------------------------------------------------")

    })

    */

    return locationArray
  }

  makeHTMLData (data) {

    console.log("data: " + JSON.stringify(data))

    let html = "";
    //  html += "<div style='font-size:1.2em; color:rgb(0,66,94); padding:0;'>&#149; " + "<b>" + data.name + "</b>" + "</div>"


    if (data.materials.length != 0) {
      data.materials.forEach((item) => {
        html += "<div style='padding:0 0 0 10px; color:rgb(0,66,94);'>" + item.name + "</div>"
      })
      html += "<hr style='opacity:.5'>"
    }

    if (data.days.length != 0) {

      data.days.sort(this.compareDays)

      html += "<hr style='opacity:.5'>"

      html += "<div style='padding:10px;'>"
      data.days.forEach((day) => {
        html += "<div style='padding:10px 0 10px 10px; color:rgba(0,66,94, .8); background-color: whitesmoke;'>&#149; " + "<span style='color:rgba(0,0,0, .8);'>" + "<b>" + this.formatDate(day.date) + "</span>" + " - " + day.name + "</b>" + "</div>"

        if (day.materials.length != 0) {
          day.materials.forEach((item) => {
            html += "<div style='padding:0 0 0 20px; color:rgb(0,66,94);'><a>" + item.name + "</a></div>"
          })
          html += "<hr style='opacity:.5'>"
        }

        html += "<hr style='opacity:.5'>"

        if (day.activities.length != 0) {

          day.activities.sort(this.compareActivities)

          html += "<div style='padding:10px;'>"
          day.activities.forEach((activity) => {
            html += "<div style='padding:5px 0 5px 10px; color:rgba(0,0,0, .6); background-color: whitesmoke;'><b>&#149; " + activity.startTime + " - " + activity.name + "</b></div>"

            if (activity.location != "none") {
              html += "<div style='padding: 0 0 0 20px; color:rgb(0,66,94);'>" + activity.location + "</div>"
            }

            if (activity.agenda.length != 0) {
              // console.log("topic.agenda: " + JSON.stringify(topic.agenda))

              activity.agenda.forEach((item) => {
                html += "<div style='padding:0 0 0 20px; color:rgb(0,66,94);'>" + item.role_name + " - " + item.member_name + "</div>"
              })
              html += "<hr style='opacity:.5'>"
            }

            if (activity.materials.length != 0) {
              activity.materials.forEach((item) => {
                html += "<div style='padding: 0 0 0 20px; color:rgb(0,66,94);'>" + item.name + "</div>"
              })
              // html += "<hr style='opacity:.5'>"
            }

            if (activity.topics.length != 0) {

              activity.topics.sort(this.compareTopics)

              html += "<div style='padding:10px;'>"
              activity.topics.forEach((topic) => {

                html += "<hr style='opacity:.5'>"

                html += "<div style='padding:0 0 0 10px; color:rgb(0,66,94);'>&#149; " + "<span style='color:rgb(0,0,0);'>" + topic.startTime + "</span>" + " - " + topic.name + " ( " + topic.duration + " min )</div>"

                /*
                if (topic.team.length != 0) {
                  topic.team.forEach((item) => {
                    html += "<div style='padding:0 0 0 20px; color:rgb(0,66,94);'>" + "<span style='color:black;'>" + item.role_name + ":</span> " + item.member_name + "</div>"
                  })
                }
                */


                if (topic.agenda.length != 0) {
                  // console.log("topic.agenda: " + JSON.stringify(topic.agenda))

                  topic.agenda.forEach((item) => {
                    html += "<div style='padding:0 0 0 20px; color:rgb(0,66,94);'>" + item.role_name + " - " + item.member_name + "</div>"
                  })
                  html += "<hr style='opacity:.5'>"
                }

                if (topic.materials.length != 0) {
                  topic.materials.forEach((item) => {
                    html += "<div style='padding:0 0 0 20px; color:rgb(0,66,94);'>" + item.name + "</div>"
                  })
                  html += "<hr style='opacity:.5'>"
                }

              })

            }

            html += "</div>"
            html += "<hr style='opacity:.5'>"
          })
          html += "</div>"
          html += "<hr style='opacity:.5'>"
        }
      })
      html += "</div>"
    }

    return html;
  }

  formatDate (date) {

    let dt: Date = new Date(date._seconds * 1000)
    let dd = (dt.getDate()).toString()
    let mm = (dt.getMonth() + 1).toString()
    let yy = dt.getFullYear().toString()

    if (dd.length == 1)
      dd = "0" + dd

    if (mm.length == 1)
      mm = "0" + mm

    return dd.toString() + "/" + mm.toString() + "/" + yy.toString()
  }

  compareDays (a: any, b: any) {

    const pa = a.date._seconds
    const pb = b.date._seconds

    //  console.log("a: " + pa)
    //  console.log("b: " + pb)

    if (pa > pb) return 1;
    if (pb > pa) return -1;

    return 0;
  }

  compareActivities (a, b) {
    const pa = String(a.startTime)
    const pb = String(b.startTime)

    if (pa > pb) return 1;
    if (pb > pa) return -1;

    return 0;
  }

  compareTopics (a, b) {

    const pa = String(a.startTime)
    const pb = String(b.startTime)

    if (pa > pb) return 1;
    if (pb > pa) return -1;

    return 0;
  }

  ////////////////////////

  compareLocation (a, b) {
    if (a.location > b.location) return 1;
    if (b.location > a.location) return -1;
    return 0;
  }

  compareTime (a, b) {
    if (a.startTime > b.startTime) return 1;
    if (b.startTime > a.startTime) return -1;
    return 0;
  }

  compareDates (a, b) {

    if (new Date(a.date._seconds * 1000) > new Date(b.date._seconds * 1000)) return 1;
    if (new Date(b.date._seconds * 1000) > new Date(a.date._seconds * 1000)) return -1;

    return 0;
  }

}
